<template>
  <div
    class="frisbuy-sr-arrow"
    :class="`frisbuy-sr-arrow--${direction}`"
    @click="$emit('click')"
  >
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 21L2 12L11 3"
        stroke="#2C2C2C"
        stroke-width="1.72"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2 12H22"
        stroke="#2C2C2C"
        stroke-width="1.72"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>

<style scoped lang="scss">
.frisbuy-sr-arrow {
  display: flex;

  &--top {
    svg {
      transform: rotate(0.25turn);
    }
  }
  &--right {
    svg {
      transform: rotate(0.5turn);
    }
  }
  &--bottom {
    svg {
      transform: rotate(-0.25turn);
    }
  }
  &--left {
    svg {
      transform: rotate(0);
    }
  }
}
</style>

<script>
export default {
  data() {
    return {};
  },

  props: {
    direction: {
      type: String,
      require: false,
      default: "left",
      validator: (value) => ["top", "right", "bottom", "left"].includes(value),
    },
  },

  emits: ["click"],
};
</script>
